/** Benchmark progress for classes that do not convert to letter grades. */
import { useOutletContext } from 'react-router-dom';
import StandardsAssessmentSection from '../StandardsAssessmentSection';
import type { ClassDetailContext } from '../classDetailTypes';

function ClassStandardsPage() {
  const { offering, isAdmin } = useOutletContext<ClassDetailContext>();
  return <StandardsAssessmentSection classOfferingId={offering.id} canConfigure={isAdmin} />;
}

export default ClassStandardsPage;
